var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FBEAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8595 32.8739L25.2226 19.1387C26.3938 16.9538 29.6062 16.9538 30.7774 19.1386L38.1405 32.8739C39.2286 34.9039 37.7155 37.3333 35.363 37.3333H20.637C18.2845 37.3333 16.7714 34.9039 17.8595 32.8739ZM28 21C28.6443 21 29.1667 21.5223 29.1667 22.1667V30.3333C29.1667 30.9777 28.6443 31.5 28 31.5C27.3557 31.5 26.8333 30.9777 26.8333 30.3333V22.1667C26.8333 21.5223 27.3557 21 28 21ZM26.5417 33.5417C26.5417 34.3471 27.1946 35 28 35C28.8054 35 29.4583 34.3471 29.4583 33.5417C29.4583 32.7363 28.8054 32.0833 28 32.0833C27.1946 32.0833 26.5417 32.7363 26.5417 33.5417Z",
    fill: "#EE4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadError);
export default __webpack_public_path__ + "static/media/file_upload_error.e24791d2bf7fc946b0e1770ce14080fc.svg";
export { ForwardRef as ReactComponent };